import DICOMFileProvider from "./DICOMFileProvider";
import WADOURIProvider from "./WADO-URI";
const Provider = {
  DICOMFileProvider,
  WADOURIProvider
};

export default Provider;
